<template>
  <div>
    <div :class="containerClass" @click="onWrapperClick">
      <div class="layout-sidebar" @click="onSidebarClick">
        <div class="layout-logo-wrapper flex items-center relative">
          <router-link
            to="/"
            class="layout-logo-text absolute left-1/2 transform -translate-x-1/2">
            <span>GESTÃO</span>
          </router-link>
          <div class="notification-btn-wrapper absolute right-0">
            <Button
              icon="pi pi-bell"
              class="notification-btn"
              @click="toggleOverlay" />
            <span v-show="ultimaMensagem" class="badge">1</span>
          </div>
        </div>
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>

      <AppTopBar :class="topBarClass" @menu-toggle="onMenuToggle" />

      <div class="layout-main-container">
        <div class="layout-main">
          <router-view />
        </div>
        <AppFooter />
      </div>

      <transition name="layout-mask">
        <div
          v-if="mobileMenuActive"
          class="layout-mask p-component-overlay"></div>
      </transition>
    </div>
    <div>
      <OverlayPanel v-if="ultimaMensagem" ref="op">
        <div
          v-for="(mensagem, index) in ultimaMensagem"
          :key="index"
          class="flex flex-column gap-3 w-25rem">
          <p><strong>Aviso Global:</strong> {{ mensagem.mensagem }}</p>
        </div>
      </OverlayPanel>
    </div>
    <div>
      <Dialog
        v-if="ultimaMensagem"
        :visible.sync="dialogVisible"
        :modal="true"
        :closable="true"
        :style="{ width: '45rem' }">
        <div v-for="(mensagem, index) in ultimaMensagem" :key="index">
          <p><strong>Aviso Global:</strong> {{ mensagem.mensagem }}</p>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import AppTopbar from './AppTopbar.vue'
import AppMenu from './AppMenu.vue'
import AppFooter from './AppFooter.vue'
import MensagemService from '@/service/MensagemService.js'
import auth from '@/modules/auth'

export default {
  components: {
    AppTopBar: AppTopbar,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
  },
  data() {
    return {
      dialogVisible: false,
      ultimaMensagem: null,
      layoutMode: 'static',
      staticMenuInactive: false,
      mobileMenuActive: false,
      menu: [],
      atualizandoToken: false,
    }
  },

  computed: {
    containerClass() {
      return [
        'layout-wrapper',
        {
          'layout-static': this.layoutMode === 'static',
          'layout-static-sidebar-inactive':
            this.staticMenuInactive && this.layoutMode === 'static',
          'layout-mobile-sidebar-active': this.mobileMenuActive,
          'p-input-filled': this.$primevue.config.inputStyle === 'filled',
          'p-ripple-disabled': this.$primevue.config.ripple === false,
        },
      ]
    },

    topBarClass() {
      return [
        {
          'layout-topbar-responsive':
            this.staticMenuInactive && this.layoutMode === 'static',
        },
      ]
    },
  },

  async created() {
    this.setaPerfil()
    const service = new MensagemService(this.$http)
    try {
      this.ultimaMensagem = await service.buscarUltimaMensagem(this.perfil)
      this.dialogVisible = true
    } catch (error) {
      console.error('Erro ao buscar última mensagem:', error)
      // Tratar erro conforme necessário
    }
    this.ativarTimerParaAtualizarToken()
    if (this.tokenExpirado()) {
      this.logout()
    }

    /* console.log(auth.roles)
    console.log(auth.hasRoleConsignatariaAdmin())
    console.log(auth.hasRoleGestao())
    console.log(auth.hasRoleGestaoAdmin())
    console.log(auth.hasRoleGestaoEntidade())
    console.log(auth.hasRoleImportarArquivoCartao())
    console.log(auth.hasRoleImportarArquivoReajusteMensalidade()) */
    this.menu = [
      {
        label: 'Home',
        visible: auth.hasRoleGestaoEntidade() || auth.hasRoleGestao(),
        items: [
          {
            label: 'Servidores',
            icon: 'pi pi-fw pi-users',
            visible: auth.hasRoleGestaoEntidade() || auth.hasRoleGestao(),
            to: { name: 'servidores' },
          },
        ],
      },
      {
        label: 'Sistema',
        icon: 'pi pi-fw pi-sitemap',
        visible:
          auth.hasRoleGestaoEntidade() ||
          auth.hasRoleGestao() ||
          auth.hasRoleGestaoFinanceira(),
        items: [
          {
            label: 'Consignatárias',
            icon: 'pi pi-fw pi-wallet',
            visible: auth.hasRoleGestaoEntidade() || auth.hasRoleGestao(),
            to: { name: 'consignatarias' },
          },
          {
            label: 'Entidades',
            icon: 'pi pi-fw pi-id-card',
            visible: auth.hasRoleGestao(),
            to: { name: 'entidades' },
          },
          {
            label: 'Atividades',
            icon: 'pi pi-fw pi-id-card',
            visible: auth.hasRoleGestao(),
            to: { name: 'atividades' },
          },
          {
            label: 'Órgãos',
            icon: 'pi pi-fw pi-building',
            visible: auth.hasRoleGestao(),
            to: { name: 'orgaos' },
          },
          {
            label: 'Rubricas',
            icon: 'pi pi-fw pi-pencil',
            visible: auth.hasRoleGestaoEntidade() || auth.hasRoleGestao(),
            to: { name: 'rubricas' },
          },
          {
            label: 'Vínculos',
            icon: 'pi pi-fw pi-link',
            visible: auth.hasRoleGestao(),
            to: { name: 'vinculos' },
          },
          {
            label: 'Grupos',
            icon: 'pi pi-fw pi-sitemap',
            visible: auth.hasRoleGestao(),
            to: { name: 'grupos' },
          },
          {
            label: 'Financeiro',
            icon: 'pi pi-fw pi-dollar',
            visible: auth.hasRoleGestao() || auth.hasRoleGestaoFinanceira(),
            items: [
              {
                label: 'Operações de Finanças',
                icon: 'pi pi-fw pi-dollar',
                visible: auth.hasRoleGestao() || auth.hasRoleGestaoFinanceira(),
                to: { name: 'financas' },
              },
              {
                label: 'Tabela de Precificação',
                icon: 'pi pi-fw pi-money-bill',
                visible: auth.hasRoleGestao(),
                to: { name: 'tabela-precificacao' },
              },
            ],
          },
          {
            label: 'Configurações',
            icon: 'pi pi-fw pi-cog',
            visible: auth.hasRoleGestao(),
            items: [
              {
                label: 'Variáveis de Margem',
                icon: 'pi pi-fw pi-chart-line',
                visible: auth.hasRoleGestao(),
                to: { name: 'configuracoes' },
              },
              {
                label: 'Painel de Mensagens',
                icon: 'pi pi-fw pi-envelope',
                visible: auth.hasRoleGestao(),
                to: { name: 'nova-mensagem' },
              },
              {
                label: 'Ajuste de Parâmetros',
                icon: 'pi pi-fw pi-cloud-upload',
                visible: auth.hasRoleGestao(),
                to: { name: 'ajuste-parametros' },
              },
            ],
          },
          {
            label: 'Usuários',
            icon: 'pi pi-user',
            visible: auth.hasRoleGestao(),
            to: { name: 'usuarios' },
          },
          {
            label: 'Arquivo',
            icon: 'pi pi-fw pi-sitemap',
            visible: auth.hasRoleGestaoEntidade() || auth.hasRoleGestao(),
            items: [
              {
                label: 'Importar Arquivo',
                icon: 'pi pi-fw pi-cloud-upload',
                visible:
                  auth.hasRoleConsignatariaAdmin() ||
                  auth.hasRoleGestao() ||
                  auth.hasRoleGestaoAdmin() ||
                  auth.hasRoleGestaoEntidade() ||
                  auth.hasRoleImportarArquivoCartao() ||
                  auth.hasRoleImportarArquivoReajusteMensalidade(),
                to: { name: 'importar-arquivo' },
              },
              {
                label: 'Gerar Arquivo Movimento',
                icon: 'pi pi-fw pi-cloud-upload',
                visible: auth.hasRoleGestaoEntidade() || auth.hasRoleGestao(),
                to: { name: 'gerar-arquivo-movimento' },
              },
            ],
          },
          {
            label: 'Relatórios',
            icon: 'pi pi-fw pi-print',
            visible:
              auth.hasRoleConsignatariaAdmin() ||
              auth.hasRoleGestao() ||
              auth.hasRoleGestaoAdmin() ||
              auth.hasRoleGestaoEntidade() ||
              auth.hasRoleGestaoFinanceira(),
            to: { name: 'relatorio' },
          },
          {
            label: 'Perfis',
            icon: 'pi pi-tag',
            visible: auth.hasRoleGestao(),
            items: [
              {
                label: 'Perfis Usuários',
                icon: 'pi pi-users',
                visible: auth.hasRoleGestao(),
                to: { name: 'perfilSeguranca' },
              },
              {
                label: 'Grupos',
                icon: 'pi pi-globe',
                visible: auth.hasRoleGestao(),
                to: { name: 'grupoSeguranca' },
              },
              {
                label: 'Roles',
                icon: 'pi pi-tag',
                visible: auth.hasRoleGestao(),
                to: { name: 'role' },
              },
            ],
          },
        ],
      },
    ]
  },

  destroyed() {
    clearInterval(this.timer)
  },

  methods: {
    toggleDialogVisibility() {
      this.dialogVisible = !this.dialogVisible
    },
    setaPerfil() {
      const hostname = window.location.hostname
      const parts = hostname.split('.')
      let subdomain
      if (parts[0] === 'dev') {
        subdomain = parts[1]
      } else {
        subdomain = parts[0]
      }
      switch (subdomain) {
        case 'gestao':
          this.perfil = 'gestao'
          this.perfilLabel = 'Gestão'
          break
        case 'consignataria':
          this.perfil = 'consignataria'
          this.perfilLabel = 'Consignatária'
          break
        case 'servidor':
          this.perfil = 'servidor'
          this.perfilLabel = 'Servidor'
          break
        default:
          this.perfil = 'servidor'
          this.perfilLabel = 'Servidor'
          break
      }
    },
    toggleOverlay(event) {
      this.$refs.op.toggle(event)
    },
    tempoRestante() {
      return this.$auth.getParsedToken().exp - Date.now() / 1000
    },

    tokenExpirado() {
      return this.tempoRestante() < 0
    },

    logout() {
      clearInterval(this.timer)
      this.$auth.logout()
      window.location.reload()
    },

    ativarTimerParaAtualizarToken() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.tokenExpirado()) {
            this.logout()
          } else if (this.tempoRestante() < 140) {
            this.$auth.refreshToken()
          }
        }, 70000)
      }
    },

    isDesktop() {
      return window.innerWidth >= 992
    },

    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false
        this.mobileMenuActive = false
      }
      this.menuClick = false
    },

    onSidebarClick() {
      this.menuClick = true
      this.overlayMenuActive = false
      this.mobileMenuActive = false
    },

    onMenuToggle() {
      this.menuClick = true
      if (this.isDesktop()) {
        this.staticMenuInactive = !this.staticMenuInactive
      } else {
        this.mobileMenuActive = !this.mobileMenuActive
      }
      event.preventDefault()
    },

    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false
        this.mobileMenuActive = false
      }
    },
  },
}
</script>

<style>
.notification-btn-wrapper {
  margin-top: 1.5rem;
  margin-right: -0.5rem;
}
.badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 0.8rem;
}
.notification-btn {
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
</style>
